export function changeFieldStatic (event) {
  console.log(this)
  this.setState({...this.state, [event.target.dataset.id]: {...this.state[event.target.dataset.id], value: event.target.value}})
}


// WEBPACK FOOTER //
// ./src/utils/changeFieldStatic.js